import React from 'react';

import ReviewItem from './ReviewItem';
import { EmptyContent } from "../../../../components";

import styles from "./ReviewsSection.module.scss";

export const ReviewsSection = ({ reviewData }) => {
	return (
		<>
			<div className={styles.sectionHeader}>Latest Reviews</div>
			<div className={styles.reviewList}>
				{reviewData && reviewData.length > 0 ? (
					reviewData.map((review) => (
						<ReviewItem key={review.id} review={review}/>
					))
				) : (
					<EmptyContent message="No reviews available" />
				)}
			</div>
		</>
	);
}
